export const COUPON_TEXT = 'Cupón válido al acumular tu primera compra u obsequio en tu evento de $500. Canjéalo en la tienda Sears de tu preferencia.';